import React from 'react';
import TravelHeader from './TravelHeader';
import TravelFooter from './TravelFooter';
import { Toaster } from '../ui/sonner';

const TravelLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <TravelHeader />
      <main className="flex-1 pt-20 lg:pt-28">
        {children}
      </main>
      <TravelFooter />
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default TravelLayout;
